import "core-js/modules/es6.array.is-array";
export default Array.isArray;